// components
import CommonActionModal from "../../Common/CommonActionModal";
import CommonForm from "../../Common/CommonForm";
import BaseApi from "../../../utils/BaseApi";
import {splitToList} from "../../../utils/misc";

// icons
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddCircleIcon from "@mui/icons-material/AddCircle";


class UltimateAdminCreateModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: AddCircleIcon,
            buttonLabel: 'Создать',
            buttonColor: 'success',
            modalLabel: 'Создание ' + this.props.model,
            modalIcon: AssignmentIcon,
            ready: true,
        })
    }

    beforeModalOpen() {
        let formFields = this.props.formFields;
        return(
            {
                mainComponent: CommonForm,
                mainComponentProps: {
                    fields: formFields,
                    processForm: this.processForm.bind(this),
                },
            }
        )
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        let url = `admin/?model=${this.props.model}`;
        const api = new BaseApi();
        let uploadFormData = new FormData()
        for (let field of this.props.formFields){
            switch (field.type){
                case 'multiselect':
                    if (field.name in formDataObj) {
                        formDataObj[field.name] = splitToList(formDataObj[field.name], ',')
                    }
                    break
                case 'file':
                    delete formDataObj[field.name]
                    let fileInput = form.state.formObject[field.name];
                    let upload = fileInput.files[0];
                    if (upload) {
                        uploadFormData.append(field.name, upload);
                    }
                    break
                case 'json':
                    if (field.name in formDataObj) {
                        formDataObj[field.name] = JSON.parse(formDataObj[field.name])
                    }
                    break
                default:
                    break
            }
        }
        let response = await api.post(
            url,
            formDataObj
        );
        if (response.status === 201) {
            url = `admin/${response.data.id}/?model=${this.props.model}`;
            let _response = await api.patch(
                url,
                uploadFormData
            );
            if (_response.status === 200) {
                if (this.props.callBack){
                    await this.props.callBack()
                }
                this.setModalOpenFalse();
            }
        }
        return response
    }
}

export default UltimateAdminCreateModal